import GridContainer from 'components/containers/GridContainer';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HorizontalGridContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <GridContainer className={`${className} ${styles.horizontalGridContainer}`} testId={testId}>
        {children}
    </GridContainer>
);

export default HorizontalGridContainer;
